export const getPayrollKey = (bid) => {
  const payroll = bid.payroll;
  const id = payroll?._id ?? payroll ?? "unknown";
  return id.toString();
};

export const getPayrollLabel = (bid) => {
  if (bid.payroll?.code) return bid.payroll.code;
  if (!bid.payroll) return "Not released";
  return getPayrollKey(bid);
};

export const getConsultantLabel = (bid) =>
  bid.wallet?.name ||
  bid.wallet?.user?.name ||
  bid.wallet?.userGroup?.name ||
  bid.commissionRow?.user?.name ||
  bid.commissionRow?.userGroup?.name ||
  "-";
